<template>
  <Tournaments title="Public Tournaments" :tournaments="publicTournaments"></Tournaments>
</template>

<script>
import Tournaments from "@/components/listingComponents/tournaments.vue";
import gql from "graphql-tag";

export default {
  name: "PublicTournaments",
  components: { Tournaments },

  apollo: {
    publicTournaments() {
      return {
        query: gql`
          query {
            publicTournaments {
              id
              name
              description
              comments
              sport
              circuit
              startDate
              endDate
              format
              location {
                name
              }
            }
          }
        `
      };
    }
  },
  methods: {
    refetch() {
      if (this.$apollo.queries.publicTournaments)
        this.$apollo.queries.publicTournaments.refetch();
    }
  },
  created() {
    // This is a temporary way of updating the location data (refetching on local change).
    // Ideally we subscribe to location-update events and refetch then, but firebase cloud functions
    // doesn't support web sockets for graphql subscriptions.
    // An alternative is to move the api off Firebase.
    // Another alternative is to do the subscription through Firebase events.
    this.$root.$on("updateTournament", id => {
      this.refetch();
    });
  }
};
</script>



// WEBPACK FOOTER //
// PublicTournaments.vue?057a9c26